import React from 'react';
import SVGImage from './SVGImage';

interface GridusTitleProps {
  textFill?: string;
}

const GridusTitle: React.FC<GridusTitleProps> = ({ textFill }) => {
  return (
    <div className="pop-title-bold flex flex-col items-center leading-none">
      <SVGImage width={34} height={34} name="gridus-logo" />
      <SVGImage
        fill={textFill ?? '#272C2D'}
        className="mt-[7px]"
        width={70}
        height={14}
        name="gridus-logo-text"
      />
    </div>
  );
};

export default GridusTitle;
